import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SidenavService } from 'src/app/shared/services/sidenav.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  constructor(private sidenavService: SidenavService, public router: Router) {}

  ngOnInit(): void {}

  clickMenu() {
    this.sidenavService.toggle();
  }

  goToHome() {
    this.router.navigate(['/']);
  }

  onLogout() {
    localStorage.removeItem('STATUS');
    this.router.navigate(['/login']);
  }
}
